import { render, staticRenderFns } from "./applyFlashsale.vue?vue&type=template&id=229bb1f5&"
import script from "./applyFlashsale.vue?vue&type=script&lang=js&"
export * from "./applyFlashsale.vue?vue&type=script&lang=js&"
import style0 from "./applyFlashsale.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports